// Initialen-Avatare (DESIGN §4.5, N6): Ton = fnv1a(id) mod 8 (neutrale Grautöne), Initialen aus Vor- und Nachname.

/** FNV-1a 32 bit über UTF-16-Codeeinheiten (stabil, ohne Abhängigkeit). */
export function fnv1a(input: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

/** Index 1–8 des Avatar-Tons für eine Person, ein Team oder eine App. */
export function avatarTone(id: string): AvatarTone {
  return ((fnv1a(id) % 8) + 1) as AvatarTone;
}

export type AvatarTone = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

/**
 * Initialen: erster Buchstabe von Vor- und Nachname, sonst die ersten zwei Buchstaben;
 * Großbuchstaben. „Liam O'Connor“ → „LO“, „Bar Assistant“ → „BA“, „Nora“ → „NO“.
 */
export function initialsOf(name: string): string {
  const words = name
    .trim()
    .split(/[\s\-_.]+/)
    .map((word) => word.replace(/[^\p{L}\p{N}]/gu, ''))
    .filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return [...words[0]!].slice(0, 2).join('').toUpperCase();
  const first = [...words[0]!][0] ?? '';
  const last = [...words.at(-1)!][0] ?? '';
  return `${first}${last}`.toUpperCase();
}

/** Tailwind-Klassen je Ton: flache Fläche ohne Verlauf (N6), statisch, damit Tailwind sie findet. */
export const AVATAR_FILLS: Record<AvatarTone, string> = {
  1: 'bg-avatar-1-from',
  2: 'bg-avatar-2-from',
  3: 'bg-avatar-3-from',
  4: 'bg-avatar-4-from',
  5: 'bg-avatar-5-from',
  6: 'bg-avatar-6-from',
  7: 'bg-avatar-7-from',
  8: 'bg-avatar-8-from',
};
